import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from 'react';
import { KeyMeasureList } from './KeyMeasureList';
import { MeasureKeyboardPanel } from './MeasureKeyboardPanel';
import { PianoMeasureList } from './PianoMeasureList';
import { useMeasurePasses, type MeasurePassId } from './hooks/use-measure-passes';
export const MeasureTab = () => {
  const $ = _c(14);
  const [currentPassId, setCurrentPassId] = useState("down-up");
  const [currentKeyNumber, setCurrentKeyNumber] = useState(null);
  const passes = useMeasurePasses();
  let t0;
  if ($[0] !== currentPassId || $[1] !== passes) {
    t0 = keyNumber => {
      setCurrentKeyNumber(keyNumber);
      const row = document.querySelector(`[data-key-number="${keyNumber}"]`);
      row?.scrollIntoView({
        block: "center"
      });
      const field = passes.find(pass => pass.id === currentPassId)?.fields[0];
      row?.querySelector(`input[name="${field}"]`)?.focus({
        preventScroll: true
      });
    };
    $[0] = currentPassId;
    $[1] = passes;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const onKeySelect = t0;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <PianoMeasureList />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== currentKeyNumber || $[5] !== currentPassId || $[6] !== onKeySelect) {
    t2 = <MeasureKeyboardPanel currentKeyNumber={currentKeyNumber} currentPassId={currentPassId} onKeySelect={onKeySelect} onPassChange={setCurrentPassId} />;
    $[4] = currentKeyNumber;
    $[5] = currentPassId;
    $[6] = onKeySelect;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== currentKeyNumber || $[9] !== currentPassId) {
    t3 = <KeyMeasureList currentKeyNumber={currentKeyNumber} currentPassId={currentPassId} onFocusKey={setCurrentKeyNumber} />;
    $[8] = currentKeyNumber;
    $[9] = currentPassId;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t2 || $[12] !== t3) {
    t4 = <div className="flex flex-col gap-5">{t1}{t2}{t3}</div>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};